<mat-toolbar>
  Residuos
  <span class="spacer"></span>
  <button mat-icon-button matTooltip="Recargar datos" (click)="ngOnInit()"><mat-icon color="primary">refresh</mat-icon></button>
  <button mat-button [matMenuTriggerFor]="beforeMenu"><mat-icon color="primary">menu</mat-icon></button>
  <mat-menu #beforeMenu="matMenu" xPosition="before">
    <button mat-menu-item (click)="newMaterial()"><mat-icon color="primary">add_circle_outline</mat-icon> Añadir residuo</button>
    <button mat-menu-item (click)="saveExcel()"><mat-icon color="primary">description</mat-icon> Exportar tabla</button>
  </mat-menu>
</mat-toolbar>

@if (showProgressBar) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<div class="pageContent">
  <div class='tableHeader'>
    <mat-form-field class='buscarInput searchMobile'>
      <mat-label>Buscar</mat-label>
      <input matInput type="text" [(ngModel)]="filter" placeholder="" (keyup)="applyFilter($event)">
    </mat-form-field>
    <div>
      <mat-form-field class='searchInput searchMobile'>
        <mat-label>Tipo</mat-label>
        <mat-select [(value)]="tipo" (selectionChange)="getMateriales()">
          <mat-option value="all">Todos</mat-option>
          <mat-option value="Clasificación">Clasificación</mat-option>
          <mat-option value="Pesaje">Pesaje</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class='searchInput searchMobile'>
        <mat-label>Estado</mat-label>
        <mat-select [(value)]="active" (selectionChange)="getMateriales()">
          <mat-option value="all">Todos</mat-option>
          <mat-option value="true">Activos</mat-option>
          <mat-option value="false">Inactivos</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class='tableBlock'>
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef > </th>
        <td mat-cell *matCellDef="let element" class='miniCell'>
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon matTooltip="Acciones">more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="editarMaterial(element.id)">
              <mat-icon color="primary">create</mat-icon>
              <span>Modificar</span>
            </button>
            <button mat-menu-item (click)="deleteMaterial(element.id)">
              <mat-icon color="primary">delete</mat-icon>
              <span>Eliminar</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>
      <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre </th>
        <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
      </ng-container>
      <ng-container matColumnDef="descripcion">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Descripción </th>
        <td mat-cell *matCellDef="let element"> {{element.descripcion}} </td>
      </ng-container>
      <ng-container matColumnDef="tipo">
        <th mat-header-cell *matHeaderCellDef> Tipo </th>
        <td mat-cell *matCellDef="let element"> {{element.tipo}} </td>
      </ng-container>
      <ng-container matColumnDef="activo">
        <th mat-header-cell *matHeaderCellDef > Activo </th>
        <td mat-cell *matCellDef="let element">
          @if (element.activo === 'true') {
            <mat-icon class='green' matTooltip="Material activo">fiber_manual_record</mat-icon>
          }
          @if (element.activo === 'false') {
            <mat-icon class='red' matTooltip="Material inactivo">fiber_manual_record</mat-icon>
          }
        </td>
      </ng-container>

      <tr class="mat-row" *matNoDataRow>
        <td class="emptyCell" colspan="5">No existen residuos...<br> <button mat-stroked-button (click)="newMaterial()">Crear residuo</button></td>
      </tr>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <mat-paginator [pageSize]="25" [pageSizeOptions]="pages" showFirstLastButtons></mat-paginator>
</div>
